import { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import { loadGoogleAnalytics } from "../../utils/analytics";

const colors = {
  bg: "#0d0d0d",
  text: "#ffffff",
  gold: "#d4af37",
  hover: "rgba(212,175,55,0.15)",
};

const slideUp = keyframes`
  from {
    transform: translateY(120%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const Bar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${colors.bg};
  color: ${colors.text};
  padding: 22px 26px;
  z-index: 99999;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;

  box-shadow: 0 -6px 28px rgba(0, 0, 0, 0.45);
  border-top: 1px solid rgba(255, 255, 255, 0.1);

  animation: ${slideUp} 0.45s ease forwards;
  font-size: 15px;
  line-height: 1.5;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 18px;
  }
`;

const Btn = styled.button`
  background: transparent;
  color: ${colors.gold};
  padding: 10px 20px;
  border-radius: 50px;
  border: 1px solid ${colors.gold};

  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.25s ease;

  &:hover {
    background: ${colors.hover};
  }
`;

const BtnAccept = styled(Btn)`
  background: ${colors.gold};
  color: #000 !important;
  border: none;

  &:hover {
    opacity: 0.9;
  }
`;

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");

    if (!consent) {
      setVisible(true);
    }

    if (consent === "accepted") {
      loadGoogleAnalytics();
    }
  }, []);

  const accept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    loadGoogleAnalytics();
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem("cookie_consent", "rejected");
    setVisible(false);
  };
  if (!visible) return null;

  return (
    <Bar>
      <div>
        Folosim cookie-uri pentru a transforma vizita ta într-o experiență mai
        plăcută și mai personală.
        <a
          href="/cookies"
          style={{ color: colors.gold, marginLeft: 6, textDecoration: "none" }}
        >
          Află mai multe
        </a>
      </div>

      <div style={{ display: "flex", gap: "12px" }}>
        <Btn onClick={reject}>Respinge</Btn>
        <BtnAccept onClick={accept}>Acceptă</BtnAccept>
      </div>
    </Bar>
  );
}
